/* Copyright (c) 2022 chilled.dev */

import React, { ErrorInfo, ReactNode } from 'react';

// Error boundaries currently have to be classes.
class ErrorBoundary extends React.Component<{
  fallback: ReactNode;
  children?: ReactNode;
}> {
  state = { hasError: false, error: new Error('Something went wrong') };
  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log('error occured', info);

    this.setState({ error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          {this.props.fallback}
          <br />
          {this.state.error?.message ?? 'Unknown error'}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
